import { Link } from 'react-router-dom';

const quickLinks = [
  { label: '首页', to: '/' },
  { label: '作品展示', to: '/works' },
  { label: '明星资料', to: '/profile' },
  { label: '影视动态', to: '/news' },
  { label: '关于本站', to: '/about' },
];

const friendLinks = ['亚洲影展', '影视资料库', '电影观察周刊', '剧集前沿'];

export default function Footer() {
  return (
    <footer className="mt-auto w-full bg-primary-900 text-background-100">
      <div className="container-page py-12 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-film-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-semibold tracking-wide">吉泽明步</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200">
              专注整理吉泽明步的影视资料与作品介绍，为影迷与影视爱好者提供系统的查询与阅读入口。
            </p>
          </div>

          <div>
            <h3 className="font-label text-sm font-semibold tracking-wide text-background-50">快速导航</h3>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="text-sm text-background-200 hover:text-accent-300 transition-colors cursor-pointer">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-label text-sm font-semibold tracking-wide text-background-50">友情链接</h3>
            <ul className="mt-4 space-y-2.5">
              {friendLinks.map((item) => (
                <li key={item}>
                  <span className="text-sm text-background-200 hover:text-accent-300 transition-colors cursor-pointer">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-label text-sm font-semibold tracking-wide text-background-50">联系方式</h3>
            <ul className="mt-4 space-y-3 text-sm text-background-200">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-300" aria-hidden="true"></i>
                contact@akiho-archive.jp
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-accent-300" aria-hidden="true"></i>
                日本 · 东京
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-300" aria-hidden="true"></i>
                工作日 10:00 - 18:00
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="container-page flex flex-col gap-2 py-5 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2023 吉泽明步影视资料站 · 本站为前端演示站点，内容仅作展示用途</p>
          <p className="text-background-300/80">All works and data are for demonstration only.</p>
        </div>
      </div>
    </footer>
  );
}